<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'activities.add_client' | translate }}
    v-card-content
      h3.card-subtitle.mb-1 {{ 'base.client_info' | translate }}
      .cols-x
        .cols-x__2.cols-x__2--offset-md
          v-text-field(
            :label="$t('base.first_name')"
            v-model="form.first_name")
        .cols-x__2.cols-x__2--offset-md
          v-text-field(
            :label="$t('base.phone')"
            v-model="form.phone")
      .cols-x
        .cols-x__2.cols-x__2--offset-md.mb-3
          v-text-field(
            :label="$t('base.last_name')"
            v-model="form.last_name")
        .cols-x__2.cols-x__2--offset-md.mb-3
          v-text-field(
            :label="$t('base.email')"
            v-model="form.email")
      .cols-x
        .cols-x__2.cols-x__2--offset-md.mb-3
          v-text-field(
            :label="$t('base.company_name')"
            v-model="form.company_name")
        .cols-x__2.cols-x__2--offset-md.mb-3
          v-text-field(
            :label="$t('base.password')"
            v-model="form.password")
      .cols-x
        .cols-x__2.cols-x__2--offset-md.mb-3.remove-margin-above-mobile
          v-text-field(
            :label="$t('base.about_client')"
            v-model="form.profile.about")
        .cols-x__2.cols-x__2--offset-md
          v-select(
            item-value="key"
            :label="$t('base.select_lang')"
            :options="languages"
            v-model="form.profile.language")
    v-divider(secondary)

    v-card-content
      h3.card-subtitle.mb-1 {{ 'activities.accesses' | translate }}
      .cols-x
        .cols-x__2.cols-x__2--offset-md.mb-3.remove-margin-above-mobile
          v-switch(
            :label="$t('activities.kkz')"
            v-model="form.kkz")
        .cols-x__2.cols-x__2--offset-md
          //- v-switch.m-none(
            label="Profeed"
            v-model="form.profeed")

    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreate") {{ 'base.save' | translate }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CreateClientModal',

  data: () => ({
    form: {
      email: '',
      password: '',
      first_name: '',
      last_name: '',
      phone: '',
      user_type: 'client',
      company_name: '',
      profile: {
        about: '',
        language: null
      },
      profeed: true,
      kkz: false
    },
    languages: [
      { id: 0, name: 'Українська', key: 'uk' },
      { id: 1, name: 'Русский', key: 'ru' },
      { id: 2, name: 'Polski', key: 'pl' },
      { id: 3, name: 'English', key: 'en' },
      { id: 4, name: 'Eesti', key: 'et' },
      { id: 5, name: 'Ελληνικά', key: 'el' },
      { id: 6, name: 'Español', key: 'es' },
      { id: 7, name: 'Español (US)', key: 'es-us' },
      { id: 8, name: 'Netherlands', key: 'nl' },
      { id: 9, name: 'Deutsch', key: 'de' },
      { id: 10, name: 'Français', key: 'fr' },
      { id: 11, name: 'Italiano', key: 'it' },
      { id: 12, name: 'Română', key: 'ro' },
      { id: 13, name: 'USA', key: 'us' },
    ],
    loading: false
  }),

  methods: {
    ...mapActions('dashboard', [
      'createUser'
    ]),

    async onCreate () {
      if (this.validateForm()) {
        const payload = {
          email: this.form.email,
          password: this.form.password,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          phone: this.form.phone,
          is_active: true,
          user_type: this.form.user_type,
          display_name: this.form.company_name,
          profile: {
            about: this.form.profile.about,
            language: this.form.profile.language,
          },
          modules: []
        }
        if (this.form.profeed) {
          payload.modules.push('profeed')
        }
        if (this.form.kkz) {
          payload.modules.push('animalfeed')
        }
        this.loading = true
        const errors = await this.createUser(payload)
        this.loading = false
        if (!errors) {
          this.$emit('update')
          this.$emit('close')
        } else {
          if (errors.email) {
            this.$toasted.show('Incorrect email!')
          } else {
            if (errors.phone) {
              this.$toasted.show('Incorrect phone!')
            } else {
              if (errors.password) {
                this.$toasted.show('Incorrect password!')
              } else {
                this.$toasted.show('Something want wrong!')
              }
            }
          }
        }
      }
    },

    validateForm () {
      if (!this.form.email) {
        this.$toasted.show('Email required!')
        return false
      }
      if (!this.form.password) {
        this.$toasted.show('Password required!')
        return false
      }
      if (this.form.password.length < 8) {
        this.$toasted.show('Password length must be equal or more than 8 symbols')
        return false
      }
      if (!this.form.first_name) {
        this.$toasted.show('Firstname required!')
        return false
      }
      if (!this.form.last_name) {
        this.$toasted.show('Lastname required!')
        return false
      }
      if (!this.form.phone) {
        this.$toasted.show('Phone required!')
        return false
      }
      if (!this.form.company_name) {
        this.$toasted.show('Company name is required!')
        return false
      }
      if (!this.form.profile.language) {
        this.$toasted.show('Language is required!')
        return false
      }
      return true
    }
  },

  watch: {
    clients () {
      this.loadFarms()
    }
  }
}
</script>
